import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';

import Travel from './travel'
import IconDeparture from '../../../images/svg/ida.js'
import IconReturn from '../../../images/svg/return.js'

const week = [6,0,1,2,3,4,5]

const firstUpperCase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

const DatetoHtml = (date, result, daysname, monthnames) => {
  if (date === undefined){
    return (result)
  } else {
    const mDate = new Date(date)
    const y = mDate.getFullYear()
    const m = mDate.getMonth()
    const d = mDate.getDate()
    const w = mDate.getDay()

    return (
      <div>
          <p>{firstUpperCase(daysname[week[w]])}, {d} {firstUpperCase(monthnames[m])} {y}</p>
      </div>
    )
  }
}

class selectionTravels extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const { daysname, monthnames } = languages[langUrl].fastbooking.calendar

    const {title, travel, list, date, select, onClickTravel, onClickOption} = this.props
    const mList = (list !== undefined)? list: []

    return (
      <div className='list-container'>
         <div className='row'>
           <div className='col-md-6 col-sm-6 col-xs-6 list-title'>
             <div className='svg-travel'>
               {(travel === 0)?
                 <IconDeparture />
               :
                 <IconReturn />
               }
             </div>
             {title}
           </div>
           <div className='col-md-6 col-sm-6 col-xs-6 list-date list-date'>
             {DatetoHtml(date, undefined, daysname, monthnames)}
           </div>
         </div>
         {mList.map((item, index) => <Travel key={index} {...item} {...this.props} select={select === index}
                    onClickTravel={() => onClickTravel(index)} onClickOption={onClickOption}/>)}
       </div>

    );
  }
}

export default connect(
	(state) => ({settings: state.settings})
)(selectionTravels)



// WEBPACK FOOTER //
// ./src/shared/routes/routeSearch/components/selectionTravels.js